<!-- Title Managers Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Title Manager</h3>
    </div>
    <div class="card-toolbar">
      <!-- Base Toolbar -->
      <div class="d-flex justify-content-end" data-kt-title-manager-table-toolbar="base">
        <!-- Filter Button -->
        <button type="button" class="btn btn-sm btn-light-primary me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Filter
        </button>

        <!-- Add Title Manager Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddTitleManagerModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Title Manager
        </button>
      </div>

      <!-- Selected Toolbar -->
      <div class="d-flex justify-content-end align-items-center d-none" data-kt-title-manager-table-toolbar="selected">
        <div class="fw-bold me-5">
          <span data-kt-title-manager-table-select="selected_count">{{ selectedTitleManagers.length }}</span> Selected
        </div>
        <button type="button" class="btn btn-danger" (click)="deleteSelectedTitleManagers()" data-kt-title-manager-table-select="delete_selected">
          Delete Selected
        </button>
      </div>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFiltersForm" [@slideInOut]>
    <div class="row g-4">
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Search Title Managers</label>
        <div class="d-flex align-items-center position-relative">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-3">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input
            type="text"
            class="form-control form-control-sm ps-10"
            placeholder="Search title managers..."
            [(ngModel)]="searchTerm"
            (keyup.enter)="applyFilters()"
          />
        </div>
      </div>
      <div class="col-md-8 d-flex align-items-end">
        <button type="button" class="btn btn-sm btn-primary me-2" (click)="applyFilters()">
          <i class="ki-duotone ki-magnifier fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="resetFilters()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Reset
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && titleManagers.length === 0" class="text-center py-10">
      <div class="text-gray-600 fs-4">No title managers found</div>
    </div>

    <!-- Data Table -->
    <div *ngIf="!isLoading && titleManagers.length > 0" class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_title_managers_table">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="w-25px text-center">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="isAllSelected()"
                  [indeterminate]="isIndeterminate()"
                  (change)="toggleAllSelection($event)">
              </div>
            </th>
            <th class="min-w-125px">Link File Name</th>
            <th class="min-w-125px">Title</th>
            <th class="min-w-150px">Description</th>
            <th class="min-w-150px">Keywords</th>
            <th class="text-center min-w-100px">Show</th>
            <th class="text-center min-w-100px">Set as Default</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngFor="let titleManager of titleManagers; trackBy: trackByFn">
            <td class="text-center pe-0">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [value]="titleManager._id"
                  [checked]="isSelected(titleManager._id)"
                  (change)="toggleSelection(titleManager._id, $event)">
              </div>
            </td>
            <td class="ps-2">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">{{ titleManager.link_file_name || 'N/A' }}</span>
                </div>
              </div>
            </td>
            <td>
              <span class="text-dark fw-bold">{{ titleManager.title || 'N/A' }}</span>
            </td>
            <td>
              <span class="text-gray-600">{{ titleManager.description || 'N/A' }}</span>
            </td>
            <td>
              <span class="text-gray-600">{{ titleManager.keywords || 'N/A' }}</span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="titleManager.show ? 'badge-light-success' : 'badge-light-danger'">
                {{ titleManager.show ? 'Show' : 'No Show' }}
              </span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="titleManager.set_as_default ? 'badge-light-success' : 'badge-light-danger'">
                {{ titleManager.set_as_default ? 'Yes' : 'No' }}
              </span>
            </td>
            <td class="text-end">
              <button
                type="button"
                class="btn btn-sm btn-icon btn-light btn-active-light-primary me-2"
                (click)="openEditModal(titleManager)"
                title="Edit">
                <i class="ki-duotone ki-pencil fs-2">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-light btn-active-light-danger"
                (click)="deleteTitleManager(titleManager)"
                title="Delete">
                <i class="ki-duotone ki-trash fs-2">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                  <span class="path4"></span>
                  <span class="path5"></span>
                </i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && titleManagers.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Title Manager Add/Edit Modal -->
<app-add-edit-title-manager
  (titleManagerAdded)="onTitleManagerAdded()"
  (titleManagerUpdated)="onTitleManagerUpdated()">
</app-add-edit-title-manager>
